import { useEffect, useState } from 'react';
import { Alert, Typography } from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';
import statusService from '../../services/StatusService';
import { isAdmin } from '../../utils/authUtils';
import { diskNotice } from '../status/diskSpace';

const CHECK_EVERY_MS = 15 * 60 * 1000;

// Admins only: nobody else can clear space, and this asks the server on every page
const DiskSpaceBanner = () => {
    const [status, setStatus] = useState(null);
    const [dismissed, setDismissed] = useState(false);
    const admin = isAdmin();

    useEffect(() => {
        if (!admin) return undefined;
        const check = () => statusService.getServerStatus().then(setStatus).catch(() => {});

        check();
        const intervalId = setInterval(check, CHECK_EVERY_MS);
        return () => clearInterval(intervalId);
    }, [admin]);

    const notice = diskNotice(status);
    if (!notice || dismissed) {
        return null;
    }

    return (
        <Alert
            severity={notice.severity}
            sx={{ mb: 2, mt: 1, display: 'flex', alignItems: 'center' }}
            icon={<StorageIcon />}
            onClose={() => setDismissed(true)}
        >
            <Typography variant="body2">
                <strong>Attention:</strong> {notice.text}
            </Typography>
        </Alert>
    );
};

export default DiskSpaceBanner;
